<div fxLayout="row" fxLayoutAlign="space-between center">
    <span fxFlexAlign="start center">{{ data.message }}</span>
    <div class="mat-simple-snackbar-action" fxFlexAlign="end">
      <button mat-button (click)="snackBarRef.dismiss()">OK</button>
    </div>
</div>
<div [innerHTML]="data.html"></div>

